import { render, staticRenderFns } from "./PowerBIReport.vue?vue&type=template&id=6466c829"
import script from "./PowerBIReport.vue?vue&type=script&lang=js"
export * from "./PowerBIReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports